<template lang='pug'>
  .box.mt-4
    h2 {{ formMode === 'add' ? 'Lisa kampaania' : 'Muuda kampaaniat' }}
    b-form(@submit.prevent="saveItem" @reset="directToList")
      b-form-group(:label="getLabel('campaignCode')" label-for="campaignCode")
        b-form-input(v-model="editableCampaignConfiguration.campaignCode" id="campaignCode" required :readonly="formMode !== 'add'")
      b-form-group(:label="getLabel('oneOffDonationSmailyCode')" label-for="oneOffDonationSmailyCode")
        b-form-input(v-model="editableCampaignConfiguration.oneOffDonationSmailyCode" id="oneOffDonationSmailyCode" number)
      b-form-group(:label="getLabel('recurringDonationSmailyCode')" label-for="recurringDonationSmailyCode")
        b-form-input(v-model="editableCampaignConfiguration.recurringDonationSmailyCode" id="recurringDonationSmailyCode" number)
      b-form-group(:label="getLabel('signatureSmailyCode')" label-for="signatureSmailyCode")
        b-form-input(v-model="editableCampaignConfiguration.signatureSmailyCode" id="signatureSmailyCode" number)
      b-form-group
        b-form-checkbox(v-model="editableCampaignConfiguration.isTotalEndpointAllowed" id="isTotalEndpointAllowed") {{ getLabel('isTotalEndpointAllowed') }}
      b-form-group
        b-form-checkbox(v-model="editableCampaignConfiguration.isContributorsEndpointAllowed" id="isContributorsEndpointAllowed") {{ getLabel('isContributorsEndpointAllowed') }}
      b-form-group
        b-form-checkbox(v-model="editableCampaignConfiguration.isTaimneTeisipaev" id="isTaimneTeisipaev") {{ getLabel('isTaimneTeisipaev') }}
      b-form-group(:label="getLabel('oneOffDonationReturnUrl')" label-for="oneOffDonationReturnUrl")
        b-form-input(v-model="editableCampaignConfiguration.oneOffDonationReturnUrl" id="oneOffDonationReturnUrl" type="url")
      b-form-group(:label="getLabel('recurringDonationDescription')" label-for="recurringDonationDescription")
        b-form-input(v-model="editableCampaignConfiguration.recurringDonationDescription" id="recurringDonationDescription")
      b-form-group(:label="getLabel('facebookPixelId')" label-for="facebookPixelId")
        b-form-input(v-model="editableCampaignConfiguration.facebookPixelId" id="facebookPixelId")
      b-form-group(:label="getLabel('facebookCapiAccessToken')" label-for="facebookCapiAccessToken")
        b-form-input(v-model="editableCampaignConfiguration.facebookCapiAccessToken" id="facebookCapiAccessToken")
      b-form-group(:label="getLabel('facebookTestEventCode')" label-for="facebookTestEventCode")
        b-form-input(v-model="editableCampaignConfiguration.facebookTestEventCode" id="facebookTestEventCode")
      b-button(type="submit" variant="primary").mr-2
          | Salvesta
      b-button(type="reset" variant="secondary")
          | Katkesta
</template>

<script>

import { authBackend } from '../api'
import * as _ from 'lodash'
import { fields } from './CampaignConfigurationList.vue'

export default {
  name: 'EditCampaignConfiguration',
  props: {
    campaignConfiguration: Object,
    mode: String
  },
  methods: {
    directToList() {
      this.$router.push({ name: 'campaign-configuration-list' })
    },
    async saveItem() {
      if (this.formMode === 'add') {
        await this.addCampaignConfiguration(this.editableCampaignConfiguration)
      } else {
        const changedValues = {}
        for (const key in this.editableCampaignConfiguration) {
          if (this.editableCampaignConfiguration[key] !== this.initialCampaignConfiguration[key]) {
            changedValues[key] = this.editableCampaignConfiguration[key]
          }
        }

        await this.patchCampaignConfiguration(this.editableCampaignConfiguration.id, changedValues)
      }

      this.directToList()
    },
    async addCampaignConfiguration(campaignConfigurationToAdd) {
      await authBackend().post('/api/campaign_configuration', campaignConfigurationToAdd)
    },
    async patchCampaignConfiguration(id, patch) {
      await authBackend().patch(`/api/campaign_configuration/${id}`, patch)
    },
    getLabel(labelKey) {
      const foundLabel = fields.find(field => field.key === labelKey)
      return foundLabel ? foundLabel.label : ''
    }
  },
  created() {
    this.formMode = this.$route.params.mode
    this.editableCampaignConfiguration = this.$route.params.campaignConfiguration || {}
    this.initialCampaignConfiguration = _.cloneDeep(this.editableCampaignConfiguration)
  }
}
</script>

<style lang="scss">

</style>
